module.exports = __webpack_public_path__ + "img/_DSC1159.98fbfc63.jpg";